Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    bp = _STYLES$useStyles.bp,
    COLORS = _STYLES$useStyles.COLORS,
    fontRegular = _STYLES$useStyles.fontRegular;
  var container_crown = {};
  if (bp.not([bp.tablet, bp.desktop])) {
    container_crown.marginTop = (0, _styles.getREM)(0.5);
  }
  var avatar = {
    width: (0, _styles.getREM)(2),
    height: (0, _styles.getREM)(2),
    borderRadius: (0, _styles.getREM)(1.5)
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    avatar.width = (0, _styles.getREM)(3);
    avatar.height = (0, _styles.getREM)(3);
  }
  var crown = {
    position: 'absolute',
    top: (0, _styles.getREM)(-1),
    left: 0,
    zIndex: 1,
    width: (0, _styles.getREM)(1.5),
    height: (0, _styles.getREM)(1.5)
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    crown.width = (0, _styles.getREM)(2);
    crown.height = (0, _styles.getREM)(2);
    crown.top = (0, _styles.getREM)(-1.25);
  }
  var defaultAvatar = Object.assign({}, fontRegular, avatar, {
    backgroundColor: colors.brand,
    justifyContent: 'center',
    alignItems: 'center'
  });
  var defaultAvatarText = {
    color: COLORS.white,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: (0, _styles.getREM)(2),
    textAlign: 'center'
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    defaultAvatarText.fontSize = _styles.STYLES.fontSize.l;
    defaultAvatarText.lineHeight = (0, _styles.getREM)(3);
  }
  var styles = _reactNative.StyleSheet.create({
    container_crown: container_crown,
    avatar: avatar,
    crown: crown,
    defaultAvatar: defaultAvatar,
    defaultAvatarText: defaultAvatarText
  });
  return {
    styles: styles
  };
};